import type { AudioRecoveryKind } from '@/types/audio-recovery';

export function normalizeRecoveryKind(value: unknown): AudioRecoveryKind {
  if (
    value === 'new-prayer' ||
    value === 'progress-update' ||
    value === 'testimony' ||
    value === 'bookmark'
  ) return value;
  // IndexedDB is an untrusted historical boundary. Missing or future values
  // are recovery material, never permission to route words into a Prayer.
  return 'unknown';
}

export function mergeRecoveredVoiceText(
  current: string,
  recovered: string,
): string {
  const left = current.trim();
  const right = recovered.trim();
  if (!right) return current;
  if (!left) return right;
  if (
    left === right ||
    left.startsWith(`${right} `) ||
    left.endsWith(` ${right}`) ||
    left.includes(` ${right} `)
  ) return current;
  // Interrupted browser capture persists the already-finalized destination
  // text followed by its last interim fragment. On resume, the live draft may
  // still contain that finalized prefix; prefer the fuller recovered value
  // instead of duplicating the prefix.
  if (right.startsWith(`${left} `)) return right;
  return `${left} ${right}`;
}

export function containsRecoveredVoiceText(
  candidate: string,
  recovered: string,
): boolean {
  const text = recovered.trim();
  if (!text) return false;
  const normalized = candidate.trim();
  return (
    normalized === text ||
    normalized.startsWith(`${text} `) ||
    normalized.endsWith(` ${text}`) ||
    normalized.includes(` ${text} `)
  );
}
